<template>
  <div>
    <transition name="bounce">
      <premium-settings />
    </transition>
    <footer-section />
  </div>
</template>

<script>
import PremiumSettings from '@/components/PremiumSettings'
import FooterSection from '@/components/FooterSection'

export default {
  components: {
    PremiumSettings,
    FooterSection
  }
}
</script>

<style lang="scss" scoped>
.center-screen {
  min-height: auto;
  margin-top: -280px;
  margin-bottom: -80px;
}
.back-btn {
  width: 200px;
  z-index: 2;
}
</style>
